<div class="bg-white w-100">

  <div class="ml-4 mt-3 tk-c-gray">{{'handover.handovers-for-vehicle' | translate}}</div>
  <div class="ml-4 font-semibold text-xl mb-4">{{selectedVehicle?.vehicleName}}</div>

  <cdk-virtual-scroll-viewport itemSize="64" minBufferPx="128" maxBufferPx="128" style="height: calc(100vh - 140px)" class="">
    <div *cdkVirtualFor="let handover of handovers" class="mx-4 my-2 h-14 " (click)="onSelect(handover)">
      <handovermod-handovers-list-item [item]="handover" [isSelected]="isItemSelected(handover)"></handovermod-handovers-list-item>
    </div>
  </cdk-virtual-scroll-viewport>

</div>
